const EVENT_COLLECTION_FIELDS = [
  'events',
  'audit_events',
  'auditTrail',
  'audit_trail',
  'activity_events',
  'activities',
  'timeline',
  'history',
  'event_timestamps',
  'activity_timestamps',
];

const EVENT_TIMESTAMP_FIELDS = [
  'created_at',
  'updated_at',
  'completed_at',
  'signed_at',
  'revoked_at',
  'usage_used_at',
  'usage_released_at',
  'usage_reserved_at',
  'email_sent_at',
  'reviewer_decision_at',
  'approved_at',
  'rejected_at',
  'opened_at',
  'sent_at',
  'at',
  'ts',
  'timestamp',
  'time',
  'occurred_at',
];

const DIRECT_ACTIVITY_TIMESTAMP_FIELDS = [
  'last_activity_at',
  'last_event_at',
  'activity_at',
  'event_at',
  'event_created_at',
  'completed_at',
  'signed_at',
  'revoked_at',
  'usage_used_at',
  'usage_released_at',
  'usage_reserved_at',
  'email_sent_at',
  'reviewer_decision_at',
  'approved_at',
  'rejected_at',
  'opened_at',
  'sent_at',
];

function timestampValue(value) {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? { time, value } : null;
}

function newestTimestamp(values) {
  return values.reduce((latest, value) => {
    const candidate = timestampValue(value);
    if (!candidate) return latest;
    return !latest || candidate.time > latest.time ? candidate : latest;
  }, null)?.value || '';
}

function collectEventTimestamps(source, timestamps) {
  if (!source) return;
  if (Array.isArray(source)) {
    source.forEach((item) => collectEventTimestamps(item, timestamps));
    return;
  }
  if (typeof source === 'string' || typeof source === 'number' || source instanceof Date) {
    timestamps.push(source);
    return;
  }
  if (typeof source !== 'object') return;
  EVENT_TIMESTAMP_FIELDS.forEach((field) => {
    if (source[field]) timestamps.push(source[field]);
  });
}

export function lastUpdatedTimestamp(row) {
  if (!row) return '';
  const activityTimestamps = [];
  EVENT_COLLECTION_FIELDS.forEach((field) => collectEventTimestamps(row[field], activityTimestamps));
  DIRECT_ACTIVITY_TIMESTAMP_FIELDS.forEach((field) => {
    if (row[field]) activityTimestamps.push(row[field]);
  });

  return newestTimestamp([
    ...activityTimestamps,
    row.updated_at,
    row.created_at,
  ]);
}
